import { isEmpty } from 'lodash/fp';
import moment from 'moment';

import { Article } from '../../../../types/__codegen__/sanity/graphql';
import { MetadataTextWrapper, MetadataWrapper } from './styles';
import { PortableTextType } from '../../../../types/sanityInternal';
import ArticleTags from '../article-tags';
import getReadTime from '../../utils/get-read-time';

type ArticleMetadataProps = {
  article: Article;
  isLeftAligned?: boolean;
};

const ArticleMetadata = ({ article, isLeftAligned }: ArticleMetadataProps) => {
  const { bodyRaw, tags, _createdAt } = article;
  const updatedAtFormatted = _createdAt ? moment.utc(_createdAt).format('DD.MM.YY') : null;
  const readTime = getReadTime(bodyRaw as PortableTextType[]);
  const readTimeFormatted = readTime > 0 ? `${readTime} min read` : null;
  const hasBothTextMetaDataTypes = updatedAtFormatted && readTimeFormatted;
  const hasMetadata = updatedAtFormatted || readTimeFormatted || tags;

  if (!hasMetadata) {
    return null;
  }

  return (
    <MetadataWrapper isLeftAligned={isLeftAligned}>
      <ArticleTags isLeftAligned={isLeftAligned} tags={tags} />
      <MetadataTextWrapper hasTags={!isEmpty(tags)}>
        {updatedAtFormatted} {hasBothTextMetaDataTypes && '|'} {readTimeFormatted}
      </MetadataTextWrapper>
    </MetadataWrapper>
  );
};

export default ArticleMetadata;
